import type React from 'react'
import { Chip } from '@/components/commons/chip'
import type { IconProps } from '@/components/ui/icons'
import type { Neighborhood } from '@/features/subgeo/types'
import { cn } from '@/helpers/utils'

interface NeighborhoodSectionProps {
	infoText: string
	infoVariant?: 'default' | 'danger'
	neighborhoods: Neighborhood[]
	chipVariant: 'neutral' | 'success' | 'danger'
	isActive: boolean
	isClickable?: boolean
	onIconClick: (neighborhoodId: string) => void
	IconComponent: React.ComponentType<IconProps>
	containerGap?: number
}

export const NeighborhoodSection = ({
	infoText,
	infoVariant = 'default',
	neighborhoods,
	chipVariant,
	isActive,
	isClickable,
	onIconClick,
	IconComponent,
	containerGap = 2
}: NeighborhoodSectionProps) => {
	return (
		<div
			className={cn('flex w-full flex-col', {
				'gap-0.5': containerGap === 0.5,
				'gap-1': containerGap === 1,
				'gap-2': containerGap === 2,
				'gap-3': containerGap === 3,
				'gap-4': containerGap === 4
			})}
		>
			<div
				className={cn('font-medium text-[13px]', {
					'text-danger-700': infoVariant === 'danger',
					'text-neutral-600': infoVariant === 'default'
				})}
			>
				{infoText}
			</div>
			<div className='flex max-h-[400px] w-full flex-row flex-wrap gap-1 overflow-y-auto [&::-webkit-scrollbar-thumb]:rounded [&::-webkit-scrollbar-thumb]:bg-neutral-300 [&::-webkit-scrollbar]:w-1'>
				{neighborhoods.map((neighborhood) => (
					<Chip
						endSlot={
							<IconComponent
								onClick={() => onIconClick(neighborhood.acp_id)}
								size={14}
							/>
						}
						isActive={isActive}
						isClickable={isClickable}
						key={neighborhood.acp_id}
						label={neighborhood.place_name}
						shape='roundedRectangle'
						size='sm'
						variant={chipVariant}
					/>
				))}
			</div>
		</div>
	)
}
